<template>
  <div class="channel h100">
    <!-- <h1>This is an channel page</h1> -->
    <el-card>
      <el-form :inline="true">
        <!-- <el-form-item label="渠道">
          <el-input placeholder="请输入渠道搜索"></el-input>
        </el-form-item> -->
        <el-form-item>
          <!-- <el-button type="primary">搜 索</el-button> -->
          <el-button type="primary" @click="change()">添加渠道</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="data" border header-cell-class-name="headerStyle" cell-class-name="cellStyle">
        <el-table-column prop="name" label="渠道"></el-table-column>
        <el-table-column prop="describe" label="描述"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间"></el-table-column>
        <el-table-column prop="updateUser" label="更新者"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <span class="operation" @click="change(scope.row)">修改</span>
            <span class="operation operation_R" @click="deleting(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog :title="title" width="30%" :visible.sync="dialog" @close='cancel()'>
      <el-form ref="editDataRef" :rules="editDataRules" :model="editData" label-width="60px">
        <el-form-item prop="name" label="渠道">
          <el-input v-model="editData.name"></el-input>
        </el-form-item>
        <el-form-item prop="describe" label="描述">
          <!-- <el-input v-model="editData.describe"></el-input> -->
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4}" v-model="editData.describe"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-w" @click="cancel()">取 消</el-button>
        <el-button class="btn" type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'channel',
  data () {
    return {
      data: [],
      type: '',
      dialog: false,
      title: '',
      id: '',
      editData: {
        name: '',
        describe: ''
      },
      editDataRules: {
        name: [
          { required: true, message: '请输入渠道', trigger: 'blur' },
          { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
        ],
        describe: [
          { required: true, message: '请输入描述', trigger: 'blur' },
          { min: 2, max: 40, message: '长度在 2 到 40 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created () {},
  mounted () {
    this.getList()
  },
  methods: {
    // 获取渠道列表
    getList () {
      this.data = []
      this.$http.get(this.API.channelList).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {
          this.data = data.data
          // 搜索用
          // this.dataFilter = data.data
        } else {
          this.data = []
          this.$message.error('接口调用失败！')
        }
        // console.log(this.data)
      })
    },
    // 修改/添加渠道判断
    change (type) {
      // console.log(type)
      this.type = ''
      this.dialog = true
      this.title = type ? '编辑' : '添加'
      this.type = type ? 'update' : 'create'
      if (type) {
        this.$nextTick(() => {
          this.id = type.id
          this.editData.name = type.name
          this.editData.describe = type.describe
        })
      }
    },
    deleting (id) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get(this.API.channelDelete, { params: { id: id } }).then((res) => {
          let data = res.data
          if (data.code === 200) {
            this.getList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('接口调用失败！')
          }
        })
      }).catch(() => {
        this.$message.warning('已取消删除！')
      })
    },
    // 取消
    cancel () {
      this.dialog = false
      this.$refs.editDataRef.resetFields()
    },
    // 确定-新增和修改渠道
    confirm () {
      if (this.type === 'update') {
        this.$refs.editDataRef.validate((valid) => {
          if (valid) {
            this.dialog = false
            this.editData.id = this.id
            // 更新渠道
            this.$http.post(this.API.channelUpdate, this.editData).then(res => {
              let data = res.data
              if (data.code === 200) {
                this.getList()
                this.$message.success('修改成功！')
                this.$refs.editDataRef.resetFields()
                // 删除ID防止新增报错
                delete this.editData.id
              } else {
                this.$message.error('接口调用失败！')
                this.$refs.editDataRef.resetFields()
              }
            })
          }
        })
      } else {
        this.$refs.editDataRef.validate((valid) => {
          if (valid) {
            this.dialog = false
            // 添加渠道
            this.$http.post(this.API.channelSave, this.editData).then((res) => {
              let data = res.data
              if (data.code === 200) {
                this.getList()
                this.$message.success('添加成功！')
                this.$refs.editDataRef.resetFields()
              } else {
                this.$message.error('接口调用失败！')
                this.$refs.editDataRef.resetFields()
              }
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
